import { Box, BoxProps, Spacer, useStyleConfig } from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { getChild } from '_helpers/index';

export type PageHeaderProps = BoxProps & {
  showBorder?: boolean;
};

const propTypes = {
  showBorder: PropTypes.bool
};

export const defaultProps = {
  showBorder: false
};

const PageHeader = (props: PageHeaderProps): React.ReactElement => {
  const { showBorder, children, __css, ...rest } = props;
  const style = useStyleConfig('PageHeaderTheme', { showBorder });

  return (
    <Box __css={mergeWith(style, __css)} {...rest}>
      {getChild(DisplayNames.PageHeaderLeftElement, children)}
      <Spacer />
      {getChild(DisplayNames.PageHeaderRightElement, children)}
    </Box>
  );
};

PageHeader.propTypes = propTypes;
PageHeader.defaultProps = defaultProps;
PageHeader.displayName = DisplayNames.PageHeader;

export default PageHeader;
